import React, { createContext, useState, useEffect, useContext } from "react";
import { Navigate } from "react-router-dom";
import { ShowToast, Severty } from "../helper/toast";
import { client } from "../utils/apiClient";
import apiPath from "../constants/apiPath";
export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [session, setSession] = useState({});
  const [isAdmin, setIsAdmin] = useState(true);
  const [userProfile, setUserProfile] = useState();
  const [authLoading, setAuthLoading] = useState(true);

  const fetchUser = async () => {
    try {
      const response = await client.get(apiPath.profile);
      setUserProfile(response.data.data);
      setIsLoggedIn(true);
      return response.data.data;
    } catch (error) {
      console.log(error);
      setIsLoggedIn(false);
      setUserProfile();
      return null;
    }
  };

  useEffect(() => {
    fetchUser().finally(() => setAuthLoading(false));
  }, []);

  useEffect(() => {
    if (!userProfile) return;
    if (userProfile.type == "Teacher") {
      setIsAdmin(false);
    }
  }, [userProfile]);

  useEffect(() => {
    if (!isLoggedIn) return;
  }, [isLoggedIn]);

  const login = () => {
    setIsLoggedIn(true);
    return <Navigate to="/dashboard" />;
  };

  const logout = () => {
    client.post(apiPath.logout).catch(() => {});
    setIsLoggedIn(false);
    setSession({});
    setUserProfile();
    ShowToast("Logout Successfully", Severty.SUCCESS);
    return <Navigate to="/login" />;
  };

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn,
        setIsLoggedIn,
        session,
        setSession,
        userProfile,
        setUserProfile,
        authLoading,
        login,
        logout,
        isAdmin,
        setIsAdmin,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuthContext = () => {
  return useContext(AuthContext);
};
